import { RichTextEditor, SectionLabel } from '@wundo/ui';
import type { MeetingReportSection } from '@wundo/shared/meetingPage.ts';
import type { RichTextEditorWiring } from '@/lib/richTextEditor.ts';
import { m } from '@/paraglide/messages.js';

export interface MeetingReportSectionCardProps {
  section: MeetingReportSection;
  onChange: (text: string) => void;
  editor: RichTextEditorWiring;
}

/**
 * One section of the verslag, editable in place.
 *
 * A section the material said nothing about keeps its heading and an empty
 * field: the structure is the conversation's, not the material's, and an empty
 * box is an invitation to write the line Wundo could not.
 */
export function MeetingReportSectionCard({
  section,
  onChange,
  editor,
}: MeetingReportSectionCardProps) {
  return (
    <section>
      <SectionLabel as='h3'>{section.title}</SectionLabel>
      <RichTextEditor
        variant='bare'
        className='mt-1'
        contentClassName='text-ink-body'
        ariaLabel={m.meeting_report_section_label({ section: section.title })}
        placeholder={m.meeting_report_section_empty()}
        value={section.text}
        onChange={onChange}
        {...editor}
      />
    </section>
  );
}
